import { z } from "@/zod";
import { ulid, phoneNumber, birthDate, dateTime } from "./commonFields";
import { GENDER } from "@/types/common";
import { pesel, peselWithValidation } from "./commonFields";
export const contractor = z.object({
  id: ulid,
  user_ref_number: z.number().optional(),
  user_id: ulid,
  cognito_id: z.string(),
  email: z.string().email(),
  first_name: z.string().min(1).trim(),
  last_name: z.string().min(1).trim(),
  full_name: z.string().trim(),
  personal_id_number: pesel,
  birth_date: birthDate,
  gender: z.enum(GENDER),
  phone_number: phoneNumber,
  registered_by_id: ulid,
  registered_by_name: z.string().trim(),
  full_name_and_personal_id_number: z.string(),
  system_role_id: z.string(),
  system_role_code: z.string(),
  system_role_name: z.string(),
  payroll_comment: z.string().max(250).optional(),
  tax_status: z.string().min(1).optional(),
  is_active: z.boolean(),
  block_agreement2: z.boolean().optional(),
  block_contests: z.boolean().optional(),
  planned_hours_approved_at: dateTime.optional(),
  planned_hours_approved_value: z.union([z.number(), z.string()]).optional(),
  deleted_at: dateTime.optional(),
});

export const readContractor = contractor.readonly();

export const createContractor = contractor
  .pick({
    email: true,
    first_name: true,
    last_name: true,
    personal_id_number: true,
    birth_date: true,
    gender: true,
    phone_number: true,
  })
  .superRefine(
    peselWithValidation({
      personalIdNumberField: "personal_id_number",
      birthDateField: "birth_date",
      genderField: "gender",
    }),
  );

export const updateContractor = contractor.pick({
  first_name: true,
  last_name: true,
  email: true,
  phone_number: true,
  payroll_comment: true,
  block_agreement2: true,
  block_contests: true,
});

export const updateContractorRestricted = updateContractor.omit({
  payroll_comment: true,
  block_agreement2: true,
  block_contests: true,
});

// Keep writeContractor for backward compatibility
export const writeContractor = createContractor;
